import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Label, Input, FormFeedback } from 'reactstrap';
import {isMobile} from 'react-device-detect';

class NameFields extends Component {
  render() {    
    return (
      <div>
        <FormGroup>
          <Label for="firstName">First Name</Label>
          <Input name="firstName" value={this.props.firstName} onChange={this.props.handleChange} id="firstName" onBlur={this.props.validateField} invalid={this.props.validation.firstName.isInvalid} autoFocus={!isMobile} maxLength="25" autoComplete="given-name" autoCapitalize="words" autoCorrect="off" />
          <FormFeedback hidden={!this.props.validation.firstName.isInvalid}>{this.props.validation.firstName.message}</FormFeedback>
        </FormGroup>
          <FormGroup>
          {/*      PBI 456177: VOA - Restriction to cardholder name fields; Changed Middle Name to Middle Initial*/}
          <Label for="middleName">Middle Initial <span>(Optional)</span></Label>
          <Input name="middleName" value={this.props.middleName} onChange={this.props.handleChange} id="middleName" onBlur={this.props.validateField} invalid={this.props.validation.middleName.isInvalid} maxLength="1" autoComplete="additional-name" autoCapitalize="words" autoCorrect="off" />
          <FormFeedback hidden={!this.props.validation.middleName.isInvalid}>{this.props.validation.middleName.message}</FormFeedback>
        </FormGroup>
        <FormGroup>
          <Label for="lastName">Last Name</Label>
          <Input name="lastName" value={this.props.lastName} onChange={this.props.handleChange} id="lastName" onBlur={this.props.validateField} invalid={this.props.validation.lastName.isInvalid} maxLength="35" autoComplete="family-name" autoCapitalize="words" autoCorrect="off" />
          <FormFeedback hidden={!this.props.validation.lastName.isInvalid}>{this.props.validation.lastName.message}</FormFeedback>
        </FormGroup>                    
      </div>);
  }
}
NameFields.defaultProps= {
  handleChange:() => {},
  firstName: "",
  middleName: "",
  lastName: "",
  validation: {    
    firstName: {
      isInvalid: false,
      message: ""
    },
    middleName: {
      isInvalid: false,
      message: ""
    },
    lastName: {
      isInvalid: false,
      message: ""
    }
  }
};

NameFields.propTypes = {
  handleChange: PropTypes.func,
};

export default NameFields;


// WEBPACK FOOTER //
// ./src/components/Fields/NameFields.js